import * as React from 'react';
import { GlobalizationContext } from '../globalization/GlobalizationContext';
/**
 * @hidden
 */
export var useLocalization = function () { return React.useContext(GlobalizationContext).localization; };
//# sourceMappingURL=useLocalization.js.map